import secureApi from "../../utils/secureApi";
import { SHOP_ENDPOINTS } from "./endpoints";

export interface ShopSellerItem {
  _id: string;
  name: string;
}

interface ShopSellerListApiResponse {
  data?: {
    paginatedResults?: ShopSellerItem[];
  } | ShopSellerItem[];
}

/**
 * Fetch list of shop sellers for scope ID selection.
 * Uses /api/v1/shop/sellers and normalizes to a flat array.
 */
export async function listShopSellersForScope(): Promise<ShopSellerItem[]> {
  try {
    const response = await secureApi.get<ShopSellerListApiResponse>(
      SHOP_ENDPOINTS.SELLERS.LIST
    );

    if (Array.isArray(response)) {
      return response as ShopSellerItem[];
    }

    if (Array.isArray(response?.data)) {
      return response.data as ShopSellerItem[];
    }

    if (Array.isArray(response?.data?.paginatedResults)) {
      return response.data.paginatedResults as ShopSellerItem[];
    }

    return [];
  } catch (error) {
    console.error("Failed to fetch shop sellers for scope IDs:", error);
    return [];
  }
}

